import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { UseMutateFunction, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const OTHER_REFERRAL_ID = 9;

const usePositionInfoMutations = (): {
  submitPositionInfo: UseMutateFunction<AxiosResponse<any>, any, any, unknown>;
  isLoading: boolean;
} => {
  const { axios } = useNetworkRequest();
  const queryClient = useQueryClient();

  const { mutate: submitPositionInfo, isLoading } = useMutation(
    (values) => axios.post(`/v3/professional/positions`, values),
    {
      onSettled: () => {
        queryClient.invalidateQueries(['currentUser']);
      },
    },
  );

  return {
    submitPositionInfo,
    isLoading,
  };
};

export default usePositionInfoMutations;
